(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    function initCartSuggestionsSwiper() {
          document.querySelectorAll('.cart-suggestions-slider').forEach((slider) => {
            if (!slider.classList.contains('swiper-initialized')) {
              new Swiper(slider, {
                wrapperClass: 'cart-suggestions-track',
                slideClass: 'cart-suggestions-item',
                slidesPerView: 1,
                spaceBetween: 20,
                loop: true,
                pagination: {
                  el: '.cart-suggestions-pagination',
                  clickable: true,
                },
                navigation: {
                  nextEl: '.cart-suggestions-next',
                  prevEl: '.cart-suggestions-prev',
                },
              });
            }
          });
        }

        document.addEventListener('DOMContentLoaded', function () {
          initCartSuggestionsSwiper();

          // Watch cart drawer for changes
          const cartDrawer = document.querySelector('.cart-drawer');
          if (cartDrawer) {
            const observer = new MutationObserver(() => {
              initCartSuggestionsSwiper();
            });
            observer.observe(cartDrawer, { childList: true, subtree: true });
          }
        });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-siblings"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
    const swapperTarget = document.querySelector("[data-swapper-target]");
    const siblingsLinks = document.querySelectorAll("[data-swapper-hover]");
    if (!swapperTarget) return;

    const defaultText = swapperTarget.textContent;

    siblingsLinks.forEach(link => {
      link.addEventListener("mouseenter", () => {
        swapperTarget.textContent = link.getAttribute("data-swapper-hover");
      });

      link.addEventListener("mouseleave", () => {
        swapperTarget.textContent = defaultText;
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
